<key-analytics-settings-filter-section
    [filters]="filters?.row"
    [values]="values?.row"
    [options]="options?.row"
    (onChange)="onChange.emit({ row: $event })"
></key-analytics-settings-filter-section>

<key-analytics-settings-filter-section
    [filters]="filters?.group"
    [values]="values?.group"
    [options]="options?.group"
    (onChange)="onChange.emit({ group: $event })"
></key-analytics-settings-filter-section>
